import { render } from "./MuteSound.vue?vue&type=template&id=1b8077eb"
import script from "./MuteSound.vue?vue&type=script&lang=js"
export * from "./MuteSound.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__